import { ISociosChart } from "../interfaces/SociosChart";
import { IContrapartesWs } from "../interfaces/Workspace";
import { Operations } from "../util/types";
import { get, post } from "./fetch";

export const getSociosChartData = async (code?:string, lang:string = "es") => {
  //Stored Procedure: DashboardSituacion_Get_Contrapartes OP:2
  var result = await get(`/api/socios${code ? "/pais/" + code : ""}${"?idioma=" + lang}`);

  return result;
}

export const getSociosPorTipoPais = async (code?:string, tipo?:number):Promise<IContrapartesWs[]> => {
  //Stored Procedure: DashboardSituacion_Get_Contrapartes OP:1
  var result = await get(`/api/socios/tipo${code ? "/" + code : ""}${tipo ? "?tipo=" + tipo : ""}`);
  return result;
}

export const getSociosDataPaises = async (code: string) => {
  //Stored Procedure: DashboardSituacion_Get_Contrapartes OP:2
  var result = await get(`/api/socios/pais/${code}`);
  return result;
}

export const getSociosDataGeneral = async () => {
  //Stored Procedure: DashboardSituacion_Get_Contrapartes OP:2
  var result = await get(`/api/socios/`);
  return result;
}

export const getSociosDataProgramas = async (code: string) => {
  //Stored Procedure: DashboardSituacion_Get_Contrapartes OP:2
  var result = await get(`/api/socios/programa/${code}`);
  return result;
}